module.exports = __webpack_public_path__ + "img/_disabled_channel.27b8efdc.svg";